
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PricingPage from "../pages/pricing/page";
import FeaturesPage from "../pages/features/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import ProjectsPage from "../pages/projects/page";
import PrivacyPage from "../pages/legal/PrivacyPage";
import CookiesPage from "../pages/legal/CookiesPage";
import LegalInfoPage from "../pages/legal/LegalInfoPage";
import TermsPage from "../pages/legal/TermsPage";
import { PATHS } from "./paths";

const routes: RouteObject[] = [
  {
    path: PATHS.home,
    element: <Home />,
  },
  {
    path: PATHS.cennik,
    element: <PricingPage />,
  },
  {
    path: PATHS.sluzby,
    element: <FeaturesPage />,
  },
  {
    path: PATHS.omne,
    element: <AboutPage />,
  },
  {
    path: PATHS.kontakt,
    element: <ContactPage />,
  },
  {
    path: PATHS.projekty,
    element: <ProjectsPage />,
  },
  {
    path: PATHS.ochranaOsobnychUdajov,
    element: <PrivacyPage />,
  },
  {
    path: PATHS.cookies,
    element: <CookiesPage />,
  },
  {
    path: PATHS.pravneInformacie,
    element: <LegalInfoPage />,
  },
  {
    path: PATHS.podmienkyPouzivania,
    element: <TermsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
